// Responsive shape within a `ResponsiveShape` background
// Wraps text widgets
export type ResponsiveShapeCell = {
  shapeId: string;
  shapeEl: HTMLElement;
  bottomPadding: number;
  topPadding: number;
  leftPadding: number;
  rightPadding: number;

  // Widget ids of the text widgets that are part of the shape
  textWidgets: string[];

  // Widget ids of the widgets that are fixed to the shape
  fixedWidgets: string[];
};

export type FixedWidget = {
  id: string;
  el: HTMLElement;
  leftWidgets: string[];
  rightWidgets: string[];
  originalWidth: number;

  // Percentage of the width of the bg shape
  paddingLeftPct?: number;
};

export enum ResizeDirection {
  Right = 'right',
  Left = 'left',
}

export type ResponsiveTextWidget = {
  id: string;
  el: HTMLElement;
  paddingBottom: number;
  isOverlappingTextWidget: boolean;

  // padding left and right from the entire group BB
  paddingLeft?: number;
  paddingRight?: number;

  originalWidth: number;
  originalLeftPx: number;

  // Object of non-text widgets below this one, and the padding from the bottom of the text
  widgetsBelow: {
    [key: string]: {
      padding: number;
      el: HTMLElement;
    };
  };
};

export type ResponsiveShape = {
  shapeId: string;
  shapeEl: HTMLElement | null;
  bottomPadding: number;
  topPadding: number;
  textWidgets: { [key: string]: ResponsiveTextWidget };
  shapeWidgets: { [key: string]: ResponsiveShapeCell };
  fixedWidgets: { [key: string]: FixedWidget };

  // TODO deprecate this
  isBackgroundShape: boolean;

  // Direction of the resize event, used to determine positioning of fixed widgets
  resizeDirection: ResizeDirection;
};

export type BackgroundShape = {
  shapeId: string;
  shapeEl: HTMLElement | null;
  bottomPadding: number;
  topPadding: number;
};
export type ResponsiveShapeOptions = {
  zoom: number;
};
